import { useState } from "react"
import { AlertCircle, Info, HelpCircle, X } from "lucide-react"
import styles from "./style.scss"
import OutlinedButton from "../button"
function Message({ type = "info", title, children, onOkay, onClose, onCancel, onConfirm, isOpen = true, }) {
    const [isVisible, setIsVisible] = useState(isOpen)

    if (!isVisible) return null

    const handleOkay = () => {
        setIsVisible(false)
        onOkay?.()
    }
    const handleClose = () => {
        setIsVisible(false)
        onClose?.()
    }
    const handleCancel = () => {
        setIsVisible(false)
        onCancel?.(true)
    }
    const handleConfirm = () => {
        setIsVisible(false)
        onConfirm?.(true)
    }
    const icons = {
        info: <Info className={`${styles.icon} ${styles.info}`} />,
        error: <AlertCircle className={`${styles.icon} ${styles.error}`} />,
        question: <HelpCircle className={`${styles.icon} ${styles.question}`} />,
    }
    return (
        <div className='overlay'>
            <div className={`${'messageBox'} ${styles[type]}`}>
                <div className={'header'}>
                    <div className={'titleRow'}>
                        {icons[type]}
                        <h3 className={'title'}>{title}</h3>
                    </div>
                    {type === "error" && (
                        <button onClick={handleClose} className={'closeButton'}>
                            <X className={'closeIcon'} />
                            <span className="sr-only">Close</span>
                        </button>
                    )}
                </div>
                <div className={'content'}>{children}</div>
                <div className={'actions'}>
                    {type === "info" && <OutlinedButton className={'primaryBtn'} onClick={handleOkay}>Okay</OutlinedButton>}
                    {type === "question" && (
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <OutlinedButton className={'secondaryBtn'} onClick={handleCancel} >Cancel</OutlinedButton>
                            <OutlinedButton className={'primaryBtn'} onClick={handleConfirm} >Confirm</OutlinedButton>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
export default Message;
